import { Stack, SvgIconProps, Tooltip } from '@mui/material';
import { ReactNode } from 'react';

import { convert } from '@/common/convert';
import { Datum } from '@/components/data/Datum';
import { DirectionIcon, DirectionIconProps } from '@/components/data/DirectionIcon';
import { SpreadIcon } from '@/components/data/SpreadIcon';
import { minorTextGrey } from '@/theme';
import { mod } from '@/utils';

export type DirectionDatumProps = DirectionIconProps & {
    spread?: number;
    tooltip?: ReactNode;
    iconSx?: SvgIconProps['sx'];
};

export const DirectionDatum = ({ type, heading, spread, unit = 'deg', tooltip, iconSx }: DirectionDatumProps) => {
    const headingDeg = mod(convert(heading).from(unit).to('deg'), 360);
    return (
        <Tooltip title={tooltip}>
            <Stack direction="row" sx={{ gap: 0.5, alignItems: 'center' }}>
                <DirectionIcon htmlColor="gray" type={type} heading={heading} sx={iconSx} />
                <Datum value={headingDeg} sourceUnit="deg" type="angle" />
                {spread && (
                    <>
                        ± <Datum value={spread / 2} sourceUnit={unit} targetUnit="deg" type="angle" />
                        <SpreadIcon
                            sx={{ color: minorTextGrey, ...iconSx }}
                            heading={heading}
                            spread={spread}
                            unit={unit}
                            type={type}
                        />
                    </>
                )}
            </Stack>
        </Tooltip>
    );
};
